import React from 'react';
import { colours } from './../helpers';
import {
  Row,
  Col
} from 'react-bootstrap';


const DevicesFrame = () => {
  const url = 'https://prtg-01-wat.ourmagnet.net/public/' +
  'mapshow.htm?id=5272&mapid=D985CDDB-FFE7-4756-AF10-D36E6D6D3A1F';

  return (
    <iframe
      width="800"
      height="600"
      src={url}
    />
  );
};

const SensorsFrame = () => {
  const url = 'https://prtg-01-wat.ourmagnet.net/public/' +
  'mapshow.htm?id=5274&mapid=45B8A0B7-B654-4AA9-AF41-3F8EAD92E3BA';

  return (
    <iframe
      width="800"
      height="600"
      src={url}
    />
  );
};

const WarningSensorsFrame = () => {
  const url = 'https://prtg-01-wat.ourmagnet.net/public/' +
  'mapshow.htm?id=4504&mapid=7A4CFA8D-456F-4792-9883-66DCE7F4B037';
  return (
    <iframe
      width="800"
      height="600"
      src={url}
    />
  );
};

const DownSensorsFrame = () => {
  const url = 'https://prtg-01-wat.ourmagnet.net/public/' +
    'mapshow.htm?id=4503&mapid=A7A90EE5-7FDF-4FB9-AAB4-79C77762E674';
  return (
    <iframe
      width="800"
      height="600"
      src={url}
    />
  );
};

const parentStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
};

const PRTGComponent = () => {
  return (
    <div>
      <Row style={parentStyle}>
        <Col>
          <Row>
            <Col>
              <h2>
                Devices
              </h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <DevicesFrame />
            </Col>
          </Row>
        </Col>

        <Col>
          <Row>
            <Col>
              <h2>
                Sensors
              </h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <SensorsFrame />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={parentStyle}>
        <Col>
          <Row>
            <Col>
              <h2 style={{ color: colours.colours.yellow }}>
                Warning Sensors
              </h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <WarningSensorsFrame />
            </Col>
          </Row>
        </Col>

        <Col>
          <Row>
            <Col>
              <h2 style={{ color: colours.colours.red }}>
                Down Sensors
              </h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <DownSensorsFrame />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PRTGComponent;


// WEBPACK FOOTER //
// src/Components/PRTGComponent.jsx